import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${({ print }) => css`
    .filiais {
      font-weight: 600;
      font-size: 16px;
      margin: 24px 0 16px;

      &:first-child {
        margin-top: 0;
      }

      & strong {
        font-weight: 600;
        font-size: 16px;
        text-decoration: underline;
      }
    }

    ${!!print
      ? css`
          .table-mobile {
            display: none;
          }
        `
      : css`
          @media (min-width: 801px) {
            .table-mobile {
              display: none;
            }
          }

          @media (max-width: 800px) {
            .table-desktop {
              display: none;
            }
          }
        `}
  `}
`

export const TableDesktop = styled.table`
  ${({ theme, print }) => css`
    width: 100%;
    border-radius: 4px;
    background: #fff;
    text-align: center;
    overflow: hidden;
    border-collapse: collapse;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);

    ${!print &&
    css`
      @media (max-width: ${theme.media.ipad}) {
        /* display: none; */
      }
    `}

    /* TABLE HEADER */
    thead tr {
      background: #f1f2f2;
    }

    thead th {
      font-weight: bold;
      font-size: 14px;
      vertical-align: middle;
      padding: 12px;

      &:nth-child(2) {
        text-align: left;
      }

      i {
        position: absolute;
        margin-left: 5px;
        background-color: #000000;
      }

      @media (max-width: ${theme.media.ipad}) {
        padding: 12px 10px;
      }
    }

    &.table-primary {
      thead tr {
        background: ${theme.colors.primary};
      }

      thead th {
        color: #ffffff;
        padding: 20px;

        i {
          background-color: #ffffff;
        }
      }
    }

    /* TABLE BODY */
    tbody tr {
      &:nth-of-type(even) {
        /* background: #f1f2f2; */

        @media (max-width: ${theme.media.ipad}) {
          /* border-top: 1px solid #c5c5c5;
          border-bottom: 1px solid #c5c5c5; */
        }
      }
    }

    tbody td {
      font-size: 12px;
      padding: 10px 12px;
      vertical-align: middle;
      min-width: 70px;
      white-space: nowrap;

      &:first-child {
        padding-right: 0;
      }

      &:nth-child(2) {
        text-align: left;
        padding-right: 2px;
        white-space: normal;
      }

      img {
        width: 60px;
      }

      @media (max-width: ${theme.media.ipad}) {
        padding: 15px 10px;
      }
    }

    ${print &&
    css`
      tbody td {
        min-width: 10px;
      }
    `}
  `}
`

export const TableMobile = styled.div`
  ${({ print }) => css`
    img {
      width: 66px;
    }

    /* ${!print &&
    css`
      display: none;
    `} */
  `}
`

export const ProductCard = styled.div`
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin-bottom: 15px;

  // Negociações > Product Card > Columns.
  .negociacoes-product-card-columns {
    display: flex;
  }

  // Negociações > Product Card > Column.
  .negociacoes-product-card-column {
    width: 70%;
  }

  // Negociações > Product Card > Header.
  .negociacoes-product-card-header {
    padding: 10px;
    font-size: 14px;

    strong {
      display: block;
    }

    .negociacoes-product-card-column {
      &:first-child {
        width: 110px;
        text-align: center;
      }
    }
  }
`

export const ProductCardHeader = styled.div`
  padding: 10px;
  font-size: 14px;

  strong {
    display: block;
  }

  .negociacoes-product-card-column {
    &:first-child {
      width: 110px;
      text-align: center;
    }
  }
`

export const ProductCardList = styled.ul`
  list-style: none;
  font-size: 14px;
`

export const ProductCardItem = styled.li`
  background: #f6f6f6;
  padding: 6px 10px;
  margin-bottom: 3px;

  &:last-child {
    background: #8f8f8f;
    border-radius: 0 0 5px 5px;
    color: #ffffff;
    margin-bottom: 0;
  }

  .negociacoes-product-card-column {
    &:last-child {
      text-align: right;
    }
  }
`
